import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  individualLoading: false,
  applicantLoading: false,
  ind_post_loading: false,
  applicantTypes: null,
  type: null,
  clientApplicationId: null,
  nafath_code: null,
  ind_personal_information_data: null,
  ind_personal_information_dropdown_data: null,
  ind_contact_information_data: null,
  ind_contact_information_dropdown_data: null,
  ind_employer_information_data: null,
  ind_employer_information_dropdown_data: null,
  ind_general_information_data: null,
  ind_general_information_dropdown_data: null,
  ind_bank_information_data: null,
  ind_bank_information_dropdown_data: null,
  ind_ksa_bank_list: [],
  ind_nonksa_bank_list: [],
  ind_investment_portfolio_data: null,
  ind_investment_portfolio_dropdown_data: null,
  ind_client_classification_data: null,
  ind_client_classification_dropdown_data: null,
  ind_tax_declaration_data: null,
  ind_tax_declaration_dropdown_data: null,
  ind_upload_document_information: null,
  ind_document_vault_data: null,
  ind_document_vault_dropdown_data: null,
  ind_application_status: null,
  delete_bank_loading: false,
  bank_loading: false,
};

export const individualSlice = createSlice({
  name: 'individual',
  initialState,
  reducers: {
    setIndividualLoading: (state, action) => {
      state.individualLoading = action.payload;
    },
    setApplicantLoading: (state, action) => {
      state.applicantLoading = action.payload;
    },
    setIndPostLoading: (state, action) => {
      state.ind_post_loading = action.payload;
    },
    setApplicantTypes: (state, action) => {
      state.applicantTypes = action.payload;
    },
    setApplicantType: (state, action) => {
      state.type = action.payload;
    },
    setClientApplicationId: (state, action) => {
      state.clientApplicationId = action.payload;
    },
    setNafathCode: (state, action) => {
      state.nafath_code = action.payload;
    },
    setIndPersonalInformationData: (state, action) => {
      state.ind_personal_information_data = action.payload;
    },
    setIndPersonalInformationDropdownData: (state, action) => {
      state.ind_personal_information_dropdown_data = action.payload;
    },
    setIndContactInformationData: (state, action) => {
      state.ind_contact_information_data = action.payload;
    },
    setIndContactInformationDropdownData: (state, action) => {
      state.ind_contact_information_dropdown_data = action.payload;
    },
    setIndEmployerInformationData: (state, action) => {
      state.ind_employer_information_data = action.payload;
    },
    setIndEmployerInformationDropdownDrop: (state, action) => {
      state.ind_employer_information_dropdown_data = action.payload;
    },
    setIndGeneralInformationData: (state, action) => {
      state.ind_general_information_data = action.payload;
    },
    setIndGeneralInformationDropdownDrop: (state, action) => {
      state.ind_general_information_dropdown_data = action.payload;
    },
    setIndBankInformationData: (state, action) => {
      state.ind_bank_information_data = action.payload;
    },
    setIndBankInformationDropdownData: (state, action) => {
      state.ind_bank_information_dropdown_data = action.payload;
    },
    setIndKsaBankList: (state, action) => {
      state.ind_ksa_bank_list = action.payload;
    },
    setIndNonksaBankList: (state, action) => {
      state.ind_nonksa_bank_list = action.payload;
    },
    setIndInvestmentPorfolioData: (state, action) => {
      state.ind_investment_portfolio_data = action.payload;
    },
    setIndInvestmentPortfolioDropdownData: (state, action) => {
      state.ind_investment_portfolio_dropdown_data = action.payload;
    },
    setIndClientClassificationData: (state, action) => {
      state.ind_client_classification_data = action.payload;
    },
    setIndClientClassificationDropdown: (state, action) => {
      state.ind_client_classification_dropdown_data = action.payload;
    },
    setIndClientClassificationDropdown: (state, action) => {
      state.ind_client_classification_dropdown_data = action.payload;
    },
    setIndTaxDeclarationData: (state, action) => {
      state.ind_tax_declaration_data = action.payload;
    },
    setIndTaxDeclarationDropdownData: (state, action) => {
      state.ind_tax_declaration_dropdown_data = action.payload;
    },
    setIndUploadDocumentInformation: (state, action) => {
      state.ind_upload_document_information = action.payload;
    },
    setIndDocumentVaultData: (state, action) => {
      state.ind_document_vault_data = action.payload;
    },
    setIndDocumentVaultDropdownData: (state, action) => {
      state.ind_document_vault_dropdown_data = action.payload;
    },
    setIndApplicationStatus: (state, action) => {
      state.ind_application_status = action.payload;
    },
    setDeleteBankLoading: (state, action) => {
      state.delete_bank_loading = action.payload;
    },
    setBankLoading: (state, action) => {
      state.bank_loading = action.payload;
    },
  },
});

export const {
  setApplicantLoading,
  setApplicantTypes,
  setIndPostLoading,
  setApplicantType,
  setClientApplicationId,
  setIndividualLoading,
  setNafathCode,
  setIndPersonalInformationData,
  setIndPersonalInformationDropdownData,
  setIndContactInformationData,
  setIndContactInformationDropdownData,
  setIndEmployerInformationData,
  setIndEmployerInformationDropdownDrop,
  setIndGeneralInformationData,
  setIndGeneralInformationDropdownDrop,
  setIndBankInformationData,
  setIndBankInformationDropdownData,
  setIndKsaBankList,
  setIndNonksaBankList,

  setIndInvestmentPorfolioData,
  setIndInvestmentPortfolioDropdownData,
  setIndClientClassificationData,
  setIndClientClassificationDropdown,
  setIndTaxDeclarationData,
  setIndTaxDeclarationDropdownData,
  setIndUploadDocumentInformation,
  setIndDocumentVaultData,
  setIndDocumentVaultDropdownData,
  setIndApplicationStatus,

  setDeleteBankLoading,
  setBankLoading,
} = individualSlice.actions;

export default individualSlice.reducer;
